import { Validators, FormBuilder } from '@angular/forms';
import { HttpUtilService } from './../services/http-util.service';
import { MatDialogRef } from '@angular/material/dialog';
import { MatDialog } from '@angular/material';
import { DOCUMENT } from '@angular/common';
import { Component, OnInit, Inject, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { OutorgaService } from '../services/outorga.service';
import { CertificadoService } from './../services/certificado.service';
import { MatRadioChange, MatRadioButton } from '@angular/material/radio';
import { TrocarOutorgaComponent } from '../trocar-outorga/trocar-outorga.component';
import { FingerPrintService } from '../services/fingerprint.service';
import { tap } from 'rxjs/operators';
import DadosFingerprintModel from '../model/dados-fingerprint.model';
import { CadastraService } from './../services/cadastra.service';
import { MessageService } from './../services/message.service';
import { ModalTermoComponent } from './../modal-termo/modal-termo.component';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { DadosCadastroMaquinaModel, TokenMaquinaModel } from '../model/cadastra-maquina.model';
import { ModalRecuperaTokenUsuarioComponent } from '../modal-recupera-token-usuario/modal-recupera-token-usuario.component';
import Utils from './../utils/utils';
import { Router } from '@angular/router';
import { GenericModalComponent } from '../generic-modal/generic-modal.component';
import { AppComponent } from './../app.component';

@Component({
  selector: 'app-cadastra-maquina',
  templateUrl: './cadastra-maquina.component.html',
  styleUrls: ['./cadastra-maquina.component.css']
})
export class CadastraMaquinaComponent implements OnInit, OnDestroy {


  @ViewChild('termo', { static: true }) myDiv: ElementRef;

  public inscricaoOutorgante: string;
  public tipoInscricaoOutorgante: string;
  private tipoInscricao;
  dadosFingerprintModel: DadosFingerprintModel;

  cpfResponsavel;
  certificado;
  enviosValue = 36500;
  situacao = 1;
  isEmpresaOutorgante;
  subscription: Subscription[] = [];
  mascara = '00.000.000/0000-00';
  lstEnvios: Object[];
  status;
  conteudoTermo: any;
  chktermo: false;
  validaTermo;
  ishabilitado;

  //variavel do model
  dadosCadastroMaquinaModel = new DadosCadastroMaquinaModel();
  tokenMaquinaModel = new TokenMaquinaModel();
 

  conteudoToken;
  termoassinado;

  constructor(private fb: FormBuilder,
              private httpUtilService: HttpUtilService,
              private outorgaService: OutorgaService,
              private certificadoService: CertificadoService,
              @Inject(DOCUMENT) private document: Document,
              public dialogRef: MatDialogRef<TrocarOutorgaComponent>,
              private fingerPrintService: FingerPrintService,
              private cadastraService: CadastraService,
              public messageService: MessageService,
              private dialog: MatDialog,
              private router: Router,
              private appComponent: AppComponent
  ) { }

  ngOnInit() {
    this.lstEnvios = this.Envios;
    this.outorgadoSubscribe();
    this.obterInscricao();
    this.cadastraService.ngOnInit();
    this.certificadoService.OnInit();
    this.ishabilitado = false;
  
  }

  
  Envios: Object[] = [
    { id: '1', name: 'Envio único', value: 0, "checked": false },
    { id: '2', name: 'Envio por 30 dias', value: 30, "checked": false },
    { id: '3', name: 'Envio por 1 ano', value: 365, "checked": false },
    { id: '4', name: 'Envio por tempo indeterminado', value: 36500, "checked": true }
  ];

  onChange(mrChange: MatRadioChange) {
    let mrButton: MatRadioButton = mrChange.source;
    this.enviosValue = mrButton.value;
  }
  /**
   * TODO
   * alterar retirar caminho fixo
   * **/
  async verificaInstalacaoCriptocnsKry(){
 
    return await this.appComponent.verificaAPICriptoCNS();
/*
    if (!GlobalCripto.clientAPI) {    
      const params = { data: {    
                  titulo: 'Mensagem do sistema',        
                  mensagem: 'Favor instalar/ativar os serviços do criptoCNS e/ou Kriptonita.',        
                }       
              }        
              this.dialog.open(ModalCnsBasicoComponent, params);    
          return false;
       
      }*/
     return false; 
  }

  openDialogKriptonita(mensagem: string, action: string,  titulo: string, labelconfirmar: string, labelcancelar: string, help: boolean): string {
    const dialogRef = this.dialog.open(GenericModalComponent, { data: { mensagem, action, titulo, labelconfirmar, labelcancelar, help} });
    return mensagem;
  }

  //Create a form
  cadastroForm = this.fb.group({
    inscricao: ['', Validators.required],
    nomeMaquina: ['', Validators.required],
    envios: '',
    situacao: 1,
    chktermo: [false, Validators.pattern('true')],
    termo: ''
  });

  get inscricao() {
    return this.cadastroForm.get('inscricao');
  }
  get nomeMaquina() {
    return this.cadastroForm.get('nomeMaquina');
  }

  obterInscricao() {
    this.certificado = this.certificadoService.obterDadosCertificadoServlet();
    const { tpInscricao, inscricao, cpfResponsavel } = this.httpUtilService.obterDadosCertificado();

    this.tipoInscricao = tpInscricao;

    if (this.isEmpresaOutorgante) {
      this.inscricao.setValue(this.inscricaoOutorgante);
     // this.tipoInscricao = this.inscricaoOutorgante.substring(0,1);
      this.tipoInscricao =  this.tipoInscricaoOutorgante;
      this.mascarar( this.tipoInscricaoOutorgante);
    } else {
      
      this.inscricao.setValue(Utils.formatarIncricao(inscricao, tpInscricao ))
      this.cpfResponsavel = Utils.formatarIncricao(cpfResponsavel,'3');
      this.mascarar(tpInscricao);
    }
  
  }


  outorgadoSubscribe() {
    this.subscription.push(this.outorgaService.getOutorgado()
      //.pipe(tap(v => console.log('Cadastro de maquina', v)))
      .pipe(tap(v => v))
      .subscribe(response => {
        if (response && response[2]) {
          this.isEmpresaOutorgante = response[2];
          this.tipoInscricaoOutorgante = response[0].toString().substring(0, 1);
          this.inscricaoOutorgante = Utils.formatarIncricao(response[0].toString().substring(1),  this.tipoInscricaoOutorgante);
          this.cpfResponsavel = Utils.formatarIncricao(response[2].cpf, '3');
        }
      }));
  }
  obterTermo(modal) {

    console.log("Termo modal SIM/NAO:: " , modal );
    if (modal)
      return this.myDiv.nativeElement.innerHTML
    else
      return this.myDiv.nativeElement.innerText;
  }


  async gravar() {
    if(this.verificaInstalacaoCriptocnsKry()){
      //limpa mensagem 
      this.messageService.deleteAllMessages();
      //dados do cadastro tela
      const inscricao = this.cadastroForm.get('inscricao').value;

      //dados da maquina do usuario (browser)
      // await this.obterDadosBrowser();
      //pega o fingerprint 
      this.dadosFingerprintModel = await this.fingerPrintService.identify(inscricao);
      //verifica token 
      this.conteudoToken = window.localStorage.getItem(inscricao);
      if (this.conteudoToken !== null) {   
        this.tokenMaquinaModel.key = inscricao;
        this.tokenMaquinaModel.jwt = this.conteudoToken;
        this.gravaMaquina();
      }
      else await this.abrirModalRecuperaTokenUsuario(inscricao);
   }
  }

  async gravaMaquina() {

    this.ishabilitado = true;
   
    //assinatura do termo  
    //this.termoassinado = await this.certificadoService.assinarTermo(this.certificado, this.obterTermo(false));
    this.termoassinado = await this.certificadoService.assinarCriptoCns(this.certificado, this.obterTermo(false), false);

    if (!this.termoassinado) {    
      this.messageService.add("Cadastro da máquina não foi realizado por não concordar com o termo.")   
      this.ishabilitado = false;
      
    } else {

      this.preencheDadosModel();
    
      //Salvar cadastro maquina
      this.status = await this.cadastraService.cadastraMaquina(this.dadosCadastroMaquinaModel,
      this.tokenMaquinaModel);
      this.ishabilitado = false;
          
    }

  }
  preencheDadosModel() {
   let pem = this.termoassinado; 
    //modal Cadastrar    
    this.dadosCadastroMaquinaModel.chaveResponsavel = "";
    this.dadosCadastroMaquinaModel.cnpjResponsavel = this.cadastroForm.get('inscricao').value;
    this.dadosCadastroMaquinaModel.cpfResponsavel = Utils.formatarIncricao(this.cpfResponsavel,'3');
    this.dadosCadastroMaquinaModel.chaveMaquina = "";
    this.dadosCadastroMaquinaModel.guid = "";
    this.dadosCadastroMaquinaModel.fingerPrint = this.dadosFingerprintModel.fingerprint;
    this.dadosCadastroMaquinaModel.nomeMaquina = this.cadastroForm.get('nomeMaquina').value;
    this.dadosCadastroMaquinaModel.qtdDiasExpiracao = this.enviosValue.toString();
    this.dadosCadastroMaquinaModel.termoAceite = pem
    this.dadosCadastroMaquinaModel.tipoInscricao = this.tipoInscricao;
    this.dadosCadastroMaquinaModel.termo =  this.obterTermo(false);
   
    console.log('**** Dados :: **** :: ' + this.dadosCadastroMaquinaModel.cpfResponsavel );
   
  }

  async abrirModalRecuperaTokenUsuario(inscricao) {
    const dialogRef = await this.dialog.open(ModalRecuperaTokenUsuarioComponent, {
      data: { inscricao: inscricao }
    });
    await dialogRef.afterClosed().subscribe(data => {
      this.tokenMaquinaModel.key = inscricao;
      this.conteudoToken = window.localStorage.getItem(inscricao);
      this.tokenMaquinaModel.jwt = this.conteudoToken;
      this.gravaMaquina();

    });
  }

  cadastrado() {
    return this.status;
  }

  ngOnDestroy() {  
    this.messageService.deleteAllMessages();
    this.subscription.forEach(s => s.unsubscribe());
  }

  openDialog() {
    const termo = this.obterTermo(true);
    this.dialog.open(ModalTermoComponent, {
      width: '750px',
      data: { termo }
    });
  }


  showOptions(event: MatCheckboxChange) {
    this.validaTermo = event.checked;

  }

  mascarar(tipo) {
    switch (tipo) {
      case '1':
        this.mascara = '00.000.000/0000-00';
        break;

      case '2':
        this.mascara = '00.000.00000/00';
        break;
      default:
        this.mascara = '000.000.000-00';
        break;
    }
  }

  onClose(){
    this.ngOnDestroy();
    this.router.navigate(['/home']);
  }

}
